export default "__VITE_ASSET__C09SciwC__"